/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlJSONLog
 */
export interface ControlJSONLog {
    /**
     * 
     * @type {boolean}
     * @memberof ControlJSONLog
     */
    debug: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlJSONLog
     */
    log: string;
    /**
     * 
     * @type {string}
     * @memberof ControlJSONLog
     */
    timestamp: string;
}

/**
 * Check if a given object implements the ControlJSONLog interface.
 */
export function instanceOfControlJSONLog(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "debug" in value;
    isInstance = isInstance && "log" in value;
    isInstance = isInstance && "timestamp" in value;

    return isInstance;
}

export function ControlJSONLogFromJSON(json: any): ControlJSONLog {
    return ControlJSONLogFromJSONTyped(json, false);
}

export function ControlJSONLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlJSONLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'debug': json['debug'],
        'log': json['log'],
        'timestamp': json['timestamp'],
    };
}

export function ControlJSONLogToJSON(value?: ControlJSONLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'debug': value.debug,
        'log': value.log,
        'timestamp': value.timestamp,
    };
}

